import { Button, Tooltip } from "@/components/ui";
import { useConfigCatFeatureFlag } from "@/network/useConfigCatFeatureFlag";
import { ShieldCheck } from "lucide-react";
import { useState } from "react";
import { EligibilityModal } from "./EligibilityModal";

export const EligibilityButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { data: isEligibilityEnabled } = useConfigCatFeatureFlag(
    "emr-surescripts-eligibility",
  );

  if (!isEligibilityEnabled) return null;

  return (
    <>
      <Tooltip
        tooltipContentText="View Eligibility"
        side="bottom"
        triggerClassName="flex items-center"
      >
        <Button
          variant="icon"
          className="m-0 p-0"
          onClick={() => setIsOpen(true)}
          aria-label="View eligibility"
        >
          <ShieldCheck className="stroke-link h-4 w-4" />
        </Button>
      </Tooltip>
      <EligibilityModal open={isOpen} onOpenChange={setIsOpen} />
    </>
  );
};
